<template>
  <v-tabs icons-and-text dense centered fixed-tabs color="transparent">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab href="#tab-2" @click="cameraPaused = true">
      Manual
      <v-icon>text_format</v-icon>
    </v-tab>
    <v-tab href="#tab-1" @click="cameraPaused = false">
      Camera
      <v-icon>camera_alt</v-icon>
    </v-tab>
    <v-tab href="#tab-3" @click="cameraPaused = true">
      Lista
      <v-icon>contacts</v-icon>
    </v-tab>
    <v-tab-item id="tab-1">
      <qrcode-validation :paused="cameraPaused" v-if="!cameraPaused" />
    </v-tab-item>
    <v-tab-item id="tab-2">
      <v-card flat>
        <text-validation />
      </v-card>
    </v-tab-item>
    <v-tab-item id="tab-3">
      <v-card flat>
        <list-validation />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import QrcodeValidation from './QRCodeValidation'
import TextValidation from './TextValidation'
import ListValidation from './ListValidation'

export default {
  components: { QrcodeValidation, TextValidation, ListValidation },
  created() {
    this.$store.dispatch('setCurrentPage', this.$store.getters.selectedEvent.name)
  },
  data() {
    return {
      cameraPaused: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/validation/ValidationTab.vue